import React, {useState, useContext, useEffect, useRef} from 'react'
import LottoService from "../../Services/Lotto.service";
import moment from "moment";
import {empty} from "../../Common/Util/functions";
import DataContext from "../../data/DataContext";
import Swal from "sweetalert2";
import $ from 'jquery'

function LottoMoney() {
  const dataConf = useContext(DataContext);
  const lottoService = new LottoService();
  const [loadingDate, setLoadingDate] = useState(false);
  const [submitting, setSubmitting] = useState(false);
  const [dateList, setDateList] = useState([]);
  const [lotData, setLotData] = useState({});
  const [lotRound, setLotRound] = useState({});
  const [summaryData, setSummaryData] = useState({});

  const firstUpdate = useRef(true);
  useEffect(()=>{
    loadDateListing()
  },[])

  const loadDateListing = () =>
  {
    if(loadingDate){
      return;
    }
    dataConf.blockUI(true)
    setLoadingDate(true);
    lottoService.zoneAll().then((result) => {
      if (result.success){
        setDateList(result.data);
      }
      else{
        Swal.fire({
          title: result.message,
          text:'',
          icon: 'warning',
          confirmButtonText: 'ตกลง',
          confirmButtonColor: '#890000',
        })
      }
      dataConf.blockUI()
      setLoadingDate(false);
    });
  }

  const getLottoMoney = (e) =>{
    e.preventDefault();
    if(submitting){
      return;
    }
    dataConf.blockUI(true)
    setSubmitting(true);
    lottoService.moneyLotto(e.target.d.value, e.target.set.value, e.target.asc.value, e.target.set_type.value).then((result) => {
      if (result.success){
        setLotData(result.data);
        setLotRound(result.round);
      }
      else{
        Swal.fire({
          title: result.message,
          text:'',
          icon: 'warning',
          confirmButtonText: 'ตกลง',
          confirmButtonColor: '#890000',
        })
      }
      dataConf.blockUI()
      setSubmitting(false);
    });
  }

  const sumMoney = (arrNumber) => {
    if(!empty(lotData.moeny) && !empty(lotData.moeny[arrNumber])){
      const sum = lotData.moeny[arrNumber].reduce((accumulator, object) => {
        return accumulator + object.lot_money;
      }, 0);

      return dataConf.money.format(sum);
    }
    else {
      return 0;
    }
  };

  const printPage = () => {
    const element = document.getElementById('table-mbox');
    element.classList.remove('table-responsive');
    window.print();
    element.classList.add('table-responsive');
  }

  const openSummaryModal = (number, type) => {
    if(submitting){
      return;
    }
    dataConf.blockUI(true)
    setSubmitting(true);
     lottoService.user(lotRound._id, $('#set_type').val(), number, type).then((result) => {
       if (result.success){
         setSummaryData(result.data);
       }
       else{
         Swal.fire({
          title: result.message,
          text:'',
          icon: 'warning',
          confirmButtonText: 'ตกลง',
          confirmButtonColor: '#890000',
        })
       }
       dataConf.blockUI()
       setSubmitting(false);
     });
  }

  return (
    <>
    <div id="lotto-money" className="p-3">
          <form onSubmit={getLottoMoney} id="main_form">
            <div className="pb-3 border-bottom row">
              <div className="mb-2 col-auto">
                <label className="control-label text-left label-1" style={{minWidth: '80px'}} htmlFor="d"> งวดวันที่ : </label>
                <select className="form-select form-select-sm d-inline" name="d" id="d" style={{width: '150px'}}>
                  {dateList.map((dateRow, index) =>
                      <option key={index} value={dateRow._id}>{moment(dateRow.limit_time).format('DD-MM-YYYY')}</option>
                  )}
                </select>
              </div>
              <div className="mb-2 col-auto">
                <label className="control-label text-left" style={{minWidth: '80px'}} htmlFor="d"> ตัดส่ง : </label>
                <select className="form-select form-select-sm ms-1 d-inline" name="mcut" id="set" style={{width: '150px'}}>
                  <option value="1">ทั้งหมด</option>
                  <option value="0">หุ้นเว็ป</option>
                </select>
              </div>
              <div className="mb-2 col-auto">
                <select className="form-select form-select-sm d-inline" name="namecut" id="asc" style={{width: '150px'}}>
                  <option value="1">เรียงตามยอด</option>
                  <option value="0">เรียงตามเลข</option>
                </select>
              </div>
              <div className="mb-2 col-auto">
                <select className="form-select form-select-sm d-inline" name="mset" id="set_type" style={{width: '150px'}}>
                  <option value="0">ทั้งหมด</option>
                  <option value="1">แบบ A</option>
                  <option value="2">แบบ B</option>
                  <option value="3">แบบ C</option>
                </select>
              </div>
              <div className="col-auto">
                <div className="d-flex">
                  <button type="button" onClick={printPage} className="btn btn-warning btn-sm me-1 mb-2">พิมพ์/ตัดส่ง</button>
                  <button type="submit" id="btn_refresh" className="btn btn-sm btn-warning me-1 mb-2">รีเฟรช</button>
                  <button type="submit" id="btn_search" className="btn btn-sm btn-warning mb-2">ค้นหา</button>
                </div>
              </div>
            </div>
          </form>
        <div className="col-md-12 mt-3">
            <h3>{(!empty(lotData.title)) && lotData.title}</h3>
            <div className="table-responsive" id="table-mbox">
              <table width="100%" border="0" cellSpacing="2" cellPadding="0" className="table table-bordered" style={{minWidth: '950px'}}>
                <tbody>
                <tr  style={{height: '40px'}}>
                  <td width="14%" align="center"><b>3บน</b></td>
                  <td width="14%" align="center"><b>3ล่าง</b></td>
                  <td width="14%" align="center"><b>3โต๊ด</b></td>
                  <td width="14%" align="center"><b>2บน</b></td>
                  <td width="14%" align="center"><b>2ล่าง</b></td>
                  <td width="16%" align="center"><strong>พิเศษ</strong></td>
                </tr>
                <tr>
                  <td align="center" valign="top" className="p-0">
                    <table width="100%" border="0" cellSpacing="1" cellPadding="0" id="tableLot1" className="table  table-bordered table-hover mb-0">
                      <thead>
                        <tr className="text-center">
                          <th width="30%" align="center">เลข</th>
                          <th width="70%" align="center">ยอด</th>
                        </tr>
                      </thead>
                      <tbody>
                      {(!empty(lotData.moeny) && !empty(lotData.moeny[1])) &&
                          <>
                            {lotData.moeny[1].map((row, index) =>
                              <tr key={index}>
                                <td onClick={()=>openSummaryModal(row.lot_number, 1)} data-bs-toggle="modal" data-bs-target="#summaryModal" align="center" className="curP">{row.lot_number}</td>
                                <td onClick={()=>openSummaryModal(row.lot_number, 1)} align="center" style={{backgroundColor:'#ffe3e3'}} data-bs-toggle="modal" data-bs-target="#summaryModal" className="curP">{dataConf.money.format(row.lot_money)}</td>
                              </tr>
                            )}
                          </>
                      }
                      </tbody>
                      <tfoot>
                      <tr>
                        <td align="center" className="text-white"><strong>รวม</strong></td>
                        <td align="center" className="text-white" id="tb1sumAll">{sumMoney(1)}</td>
                      </tr>
                      </tfoot>
                    </table>
                  </td>
                  <td align="center" valign="top" className="p-0">
                    <table width="100%" border="0" cellSpacing="1" cellPadding="0" id="tableLot2" className="table  table-bordered table-hover mb-0">
                      <thead>
                      <tr className="text-center">
                        <th width="30%" align="center">เลข</th>
                        <th width="70%" align="center">ยอด</th>
                      </tr>
                      </thead>
                      <tbody>
                      {(!empty(lotData.moeny) && !empty(lotData.moeny[2])) &&
                          <>
                            {lotData.moeny[2].map((row, index) =>
                                <tr key={index}>
                                  <td onClick={()=>openSummaryModal(row.lot_number, 2)} data-bs-toggle="modal" data-bs-target="#summaryModal" align="center" className="curP">{row.lot_number}</td>
                                  <td onClick={()=>openSummaryModal(row.lot_number, 2)} align="center" style={{backgroundColor:'#ffe3e3'}} data-bs-toggle="modal" data-bs-target="#summaryModal" className="curP">{dataConf.money.format(row.lot_money)}</td>
                                </tr>
                            )}
                          </>
                      }
                      </tbody>
                      <tfoot>
                      <tr>
                        <td align="center" className=" text-white"><strong>รวม</strong></td>
                        <td align="center" className=" text-white" id="tb2sumAll">{sumMoney(2)}</td>
                      </tr>
                      </tfoot>
                    </table>
                  </td>
                  <td align="center" valign="top" className="p-0">
                    <table width="100%" border="0" cellSpacing="1" cellPadding="0" id="tableLot3" className="table  table-bordered table-hover mb-0">
                      <thead>
                      <tr className="text-center">
                        <th width="30%" align="center">เลข</th>
                        <th width="70%" align="center">ยอด</th>
                      </tr>
                      </thead>
                      <tbody>
                      {(!empty(lotData.moeny) && !empty(lotData.moeny[3])) &&
                          <>
                            {lotData.moeny[3].map((row, index) =>
                                <tr key={index}>
                                  <td onClick={()=>openSummaryModal(row.lot_number, 3)} data-bs-toggle="modal" data-bs-target="#summaryModal" align="center" className="curP">{row.lot_number}</td>
                                  <td onClick={()=>openSummaryModal(row.lot_number, 3)} align="center" style={{backgroundColor:'#ffe3e3'}} data-bs-toggle="modal" data-bs-target="#summaryModal" className="curP">{dataConf.money.format(row.lot_money)}</td>
                                </tr>
                            )}
                          </>
                      }
                      </tbody>
                      <tfoot>
                      <tr>
                        <td align="center" className=" text-white"><strong>รวม</strong></td>
                        <td align="center" className=" text-white" id="tb3sumAll">{sumMoney(3)}</td>
                      </tr>
                      </tfoot>
                    </table>
                  </td>
                  <td align="center" valign="top" className="p-0">
                    <table width="100%" border="0" cellSpacing="1" cellPadding="0" id="tableLot4" className="table  table-bordered table-hover mb-0">
                      <thead>
                      <tr className="text-center">
                        <th width="30%" align="center">เลข</th>
                        <th width="70%" align="center">ยอด</th>
                      </tr>
                      </thead>
                      <tbody>
                      {(!empty(lotData.moeny) && !empty(lotData.moeny[4])) &&
                          <>
                            {lotData.moeny[4].map((row, index) =>
                                <tr key={index}>
                                  <td onClick={()=>openSummaryModal(row.lot_number, 4)} data-bs-toggle="modal" data-bs-target="#summaryModal" align="center" className="curP">{row.lot_number}</td>
                                  <td onClick={()=>openSummaryModal(row.lot_number, 4)} align="center" style={{backgroundColor:'#ffe3e3'}} data-bs-toggle="modal" data-bs-target="#summaryModal" className="curP">{dataConf.money.format(row.lot_money)}</td>
                                </tr>
                            )}
                          </>
                      }
                      </tbody>
                      <tfoot>
                      <tr>
                        <td align="center" className=" text-white"><strong>รวม</strong></td>
                        <td align="center" className=" text-white" id="tb4sumAll">{sumMoney(4)}</td>
                      </tr>
                      </tfoot>
                    </table>
                  </td>
                  <td align="center" valign="top" className="p-0">
                    <table width="100%" border="0" cellSpacing="1" cellPadding="0" id="tableLot5" className="table  table-bordered table-hover mb-0">
                      <thead>
                      <tr className="text-center">
                        <th width="30%" align="center">เลข</th>
                        <th width="70%" align="center">ยอด</th>
                      </tr>
                      </thead>
                      <tbody>
                      {(!empty(lotData.moeny) && !empty(lotData.moeny[5])) &&
                          <>
                            {lotData.moeny[5].map((row, index) =>
                                <tr key={index}>
                                  <td onClick={()=>openSummaryModal(row.lot_number, 5)} data-bs-toggle="modal" data-bs-target="#summaryModal" align="center" className="curP">{row.lot_number}</td>
                                  <td onClick={()=>openSummaryModal(row.lot_number, 5)} align="center" style={{backgroundColor:'#ffe3e3'}} data-bs-toggle="modal" data-bs-target="#summaryModal" className="curP">{dataConf.money.format(row.lot_money)}</td>
                                </tr>
                            )}
                          </>
                      }
                      </tbody>
                      <tfoot>
                      <tr>
                        <td align="center" className=" text-white"><strong>รวม</strong></td>
                        <td align="center" className=" text-white" id="tb5sumAll">{sumMoney(5)}</td>
                      </tr>
                      </tfoot>
                    </table>
                  </td>
                  <td align="center" valign="top"></td>
                </tr>
                </tbody>
              </table>
            </div>
        </div>
    </div>
     <SummaryModal data={summaryData}/>
     </>
  )
}

function SummaryModal(props) {

  const data = props.data;
  const dataConf = useContext(DataContext);

  return(
      <div className="modal fade" id="summaryModal" tabIndex="-1" aria-labelledby="summaryModalLabel"
           aria-hidden="true">
        <div className="modal-dialog modal-xl">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title" id="summaryModalLabel">รายละเอียด</h5>
              <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>
            <div id="lotto-money" className="modal-body">
              {(!empty(data) && !empty(data.list)) &&
                  <table width="100%" cellSpacing="0" id="tablelist" className="table table-bordered table-hover">
                    <thead>
                    <tr>
                      <th scope="col">รหัสบิล</th>
                      <th scope="col">ซุปเปอร์</th>
                      <th scope="col">เมมเบอร์</th>
                      <th scope="col">วันที่ซื้อ</th>
                      <th scope="col">งวด</th>
                      <th scope="col">ประเภท</th>
                      <th scope="col">หมายเลข</th>
                      <th scope="col">จำนวนเงินที่เล่น</th>
                      <th scope="col">ถือสู้</th>
                      <th scope="col">คาดเดาเสีย</th>
                    </tr>
                    </thead>
                    <tbody>
                    {data.list.map((row) =>
                        <tr key={row.play_id}>
                          <td className="text-center">{row.play_id}</td>
                          <td className="text-center">{row.r_user}</td>
                          <td className="text-center">{row.m_user}</td>
                          <td className="text-center">{moment(row.play_datenow).format('DD-MM-YYYY HH:mm:ss')}</td>
                          <td className="text-center">{moment(row.ok_date).format('DD-MM-YYYY')}</td>
                          <td className="text-center">{row.lot_type_name}</td>
                          <td className="text-center">{row.play_number}</td>
                          <td className="text-end">{dataConf.money.format(row.b_total)}</td>
                          <td className="text-end">{dataConf.money.format(row.b_total_share)}</td>
                          <td className="text-end text-danger">-{dataConf.money.format(row.guess_loss)}</td>
                        </tr>
                    ) }
                    </tbody>
                    <tfoot>
                    <tr>
                      <th colSpan="6"></th>
                      <th>รวม:</th>
                      <th className="text-end">
                        {dataConf.money.format(data.list.reduce((v,e)=>{
                          return v+e.b_total;
                        },0))}
                      </th>
                      <th className="text-end">
                        {dataConf.money.format(data.list.reduce((v,e)=>{
                          return v+e.b_total_share;
                        },0))}
                      </th>
                      <th className="text-end text-light">
                        -
                        {dataConf.money.format(data.list.reduce((v,e)=>{
                          return v+e.guess_loss;
                        },0))}
                      </th>
                    </tr>
                    </tfoot>
                  </table>
              }
            </div>
            <div className="modal-footer">
              <button type="button" className="btn btn-secondary" data-bs-dismiss="modal">ปิด</button>
            </div>
          </div>
        </div>
      </div>
  )

}

export default LottoMoney